function nhsCarousel(name) {
    document.querySelectorAll(name).forEach(function (carousel) {
        var splide = new Splide(carousel, {
            pagination: true,
            arrows: true,
            type: 'loop',
            autoplay: true,
            rewind: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            heightRatio: 0.5625,
            breakpoints: {
                990: {
                    heightRatio: 0.5
                },
                480: {
                    heightRatio: 1.2
                }
            }
        });

        splide.mount();

        var toggle = carousel.querySelector('.carousel-slider__toggle');
        var autoplay = splide.Components.Autoplay;

        if (toggle && autoplay) {
            var playing = true;
            toggle.classList.add('is-active'); // starts playing, show pause icon

            toggle.addEventListener('click', function () {
                if (playing) {
                    autoplay.pause();
                    toggle.classList.remove('is-active');
                    toggle.setAttribute('aria-label', 'Play autoplay');
                } else {
                    autoplay.play();
                    toggle.classList.add('is-active');
                    toggle.setAttribute('aria-label', 'Pause autoplay');
                }
                playing = !playing;
            });
        }
    });
}
